import {Injectable} from '@angular/core';
import {WebSocketService} from './webscoket.service';
import {NotificationService} from './notification.service';
import { Router } from '@angular/router';
import {WSMessageType} from '../../conversations/contracts/message.interface';
import {Title} from "@angular/platform-browser";
import {AuthService} from "../../auth/services/auth.service";

@Injectable({ providedIn: 'root' })
export class NotificationHandlerService {
  private unreadCount = 0;
  private readonly APP_TITLE = 'Keyconnect';

  constructor(
    private wsService: WebSocketService,
    private notificationService: NotificationService,
    private router: Router,
    private titleService: Title,
    private authService: AuthService
  ) {}

  init(): void {
    this.wsService.messages$
      .subscribe(wsMessage => {
        if (wsMessage.isErrorMessage) return;

        const isOnConversationPage = this.router.url.includes('/assignments') || this.router.url.includes('/conversations');
        const currentUser = this.authService.getCurrentUser();
        const myId = currentUser?.id;

        switch (wsMessage.type) {
          case WSMessageType.CHAT: {
            // Skip messages sent by the current user
            if (wsMessage.content?.userId === myId) return;
            if (!isOnConversationPage || !document.hasFocus()) {
              this.incrementUnreadCount();
            }
            break;
          }

          case WSMessageType.CONVERSATION_CREATED: {
            // New TO_ASSIGN conversation (manual creation)
            if (!isOnConversationPage || !document.hasFocus()) {
              this.notificationService.info('Nuova conversazione');
              this.incrementUnreadCount();
            }
            break;
          }

          case WSMessageType.CONVERSATION_UPDATED: {
            const conversation = wsMessage.content;
            const isAssignedToMe =
              conversation?.assignment?.assignedUserId === myId &&
              conversation?.status === 'ASSIGNED_PENDING';

            // Only notify when completely off the conversation page — the
            // conversations-list component handles in-page toasts itself.
            if (isAssignedToMe && !isOnConversationPage) {
              this.notificationService.info('Nuova conversazione assegnata');
              this.incrementUnreadCount();
            }
            break;
          }
        }
      });

    // Reset count when window gains focus
    window.addEventListener('focus', () => {
      if (this.router.url.includes('/assignments') || this.router.url.includes('/conversations')) {
        this.resetUnreadCount();
      }
    });

    this.router.events.subscribe(() => {
      if (this.router.url.includes('/assignments') || this.router.url.includes('/conversations')) {
        this.resetUnreadCount();
      }
    });
  }

  private incrementUnreadCount() {
    this.unreadCount++;
    this.updateTitle();
  }

  private resetUnreadCount() {
    this.unreadCount = 0;
    this.updateTitle();
  }

  private updateTitle() {
    if (this.unreadCount > 0) {
      this.titleService.setTitle(`(${this.unreadCount}) ${this.APP_TITLE}`);
    } else {
      this.titleService.setTitle(this.APP_TITLE);
    }
  }
}
